import * as React from "react";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import CardActions from "@mui/joy/CardActions";
import CardOverflow from "@mui/joy/CardOverflow";
import "react-international-phone/style.css";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import { Grid } from "@mui/material";
import {
  addEquipmentChecklist,
  updateEquipmentChecklist,
} from "../../service/equipmentChecklistService";
import { RadioButton } from "primereact/radiobutton";
import { TabPanel, TabView } from "primereact/tabview";
import { s3GetUrl } from "../../service/s3Service";
import { useEffect } from "react";

export default function EquipmentChecklistSubmissionView(modalProps: any) {
  const record = modalProps?.record;

  console.log("record == ", record);

  const risk = record?.risk || [];
  const safe = record?.safe || [];

  const [image, setImage] = React.useState<any>(null);

  useEffect(() => {
    if (!record) return;
    getImageUrl(record.signature_s3_key);
  }, [record]);

  async function getImageUrl(s3Key?: string) {
    if (!s3Key) return null;
    const url = await s3GetUrl(s3Key);
    return url;
  }

  const equipment = modalProps?.record_id;

  // async function Add() {
  //   let updateDetails: any = {
  //     question: question,
  //     equipment: equipment,
  //     type: type,
  //   };
  //   modalProps.setGlobalLoading(true);
  //   if (record?.id) {
  //     updateEquipmentChecklist(updateDetails, record.id).then((r: any) => {
  //       modalProps.toast.current.show({
  //         severity: "success",
  //         summary: "Equipment Checklist Updated Successfully",
  //         life: 3000,
  //       });
  //       modalProps.setVisible(false);
  //       modalProps.setGlobalLoading(false);
  //       modalProps.setReload(!modalProps.reload);
  //     });
  //   } else {
  //     addEquipmentChecklist(updateDetails).then((r: any) => {
  //       modalProps.setGlobalLoading(false);
  //       modalProps.toast.current.show({
  //         severity: "success",
  //         summary: "Equipment Checklist Added Successfully",
  //         life: 3000,
  //       });
  //       modalProps.setReload(!modalProps.reload);
  //       modalProps.setVisible(false);
  //     });
  //   }
  // }

  const getStatus = (status: string) => {
    switch (status) {
      case "Non-compliant":
        return "❌ Non-compliant";
      case "Compliant":
        return "✅ Compliant";
      case "Not Applicable":
      default:
        return "━ Not Applicable";
    }
  };

  return (
    <React.Fragment>
      <TabView>
        <TabPanel header="Risk">
          {risk.map((item: any, index: number) => {
            return (
              <Grid key={`Risk-${index}`} container spacing={2}>
                <Grid item xs={6}>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <FormLabel>{item?.question}</FormLabel>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <FormLabel>{getStatus(item?.status)}</FormLabel>
                  </FormControl>
                </Grid>
              </Grid>
            );
          })}
        </TabPanel>
        <TabPanel header="Safe">
          {safe.map((item: any, index: number) => {
            return (
              <Grid key={`Safe-${index}`} container spacing={2}>
                <Grid item xs={6}>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <FormLabel>{item?.question}</FormLabel>
                  </FormControl>
                </Grid>
                <Grid item xs={6}>
                  <FormControl
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  >
                    <FormLabel>{getStatus(item?.status)}</FormLabel>
                  </FormControl>
                </Grid>
              </Grid>
            );
          })}
        </TabPanel>
      </TabView>
      <br />
      <br />
      {image && <img style={{ height: 80, float: "right" }} src={image} />}

      <CardOverflow
        style={{ width: "100%" }}
        sx={{ borderTop: "1px solid", borderColor: "divider" }}
      >
        <CardActions style={{ marginTop: 15 }} sx={{ alignSelf: "flex-end", pt: 2 }}>
          <Button
            type="button"
            icon="pi pi-save"
            label="Save"
            className="p-button-outlined"
            size="small"
            style={{
              position: "absolute",
              fontSize: "small",
              right: 0,
              color: "#2dd36f",
            }}
            onClick={() => {}}
          />
        </CardActions>
      </CardOverflow>
    </React.Fragment>
  );
}
